/* eslint-disable @typescript-eslint/no-floating-promises */
import { useState, useEffect } from 'react';
import { message as messageAntd } from 'antd';

const useSuccess = <T>(success: T, message = 'Acción realizada con éxito'): T => {
  const [successValue, setSuccessValue] = useState<T>(success);

  useEffect(() => {
    if (success) {
      setSuccessValue(success);
      messageAntd.success(message, 5);
    }
  }, [success, message]);
  return successValue;
};

export default useSuccess;
